export default __webpack_public_path__ + "static/media/add-file.f3512ed1.svg";